import type { ReactNode } from "react";
import { cn } from "@/lib/utils";
const PLACEMENT_CLASS = {
  page: "text-display font-normal leading-none tracking-[-0.025em]",
  bar: "truncate text-callout font-medium"
} as const;
export function PageTitle({
  children,
  placement = "page",
  variant = "app",
  className
}: {
  children: ReactNode;
  placement?: keyof typeof PLACEMENT_CLASS;
  variant?: "app" | "record";
  className?: string;
}) {
  const Tag = placement === "page" ? "h1" : "p";
  return <Tag className={cn(PLACEMENT_CLASS[placement], "text-ink", variant === "record" && "min-w-0 font-mono", className)} data-sentry-element="Tag" data-sentry-component="PageTitle" data-sentry-source-file="PageTitle.tsx">
            {children}
        </Tag>;
}